// extracted by mini-css-extract-plugin
export default {"ptitle":"PokemonTitle_ptitle__cXmJU","pheading":"PokemonTitle_pheading__aSPNo","heading":"PokemonTitle_heading__cz35B"};